import '@theme-modern-js/bootstrap';
import '@theme-modern-js/paginate';
import 'easy-autocomplete/dist/jquery.easy-autocomplete';
import '@theme-modern-js/modules/alert';
import '@theme-modern-js/modules/modal-attachables';
import '@theme-modern-js/modules/header';
import '@theme-modern-js/modules/main-swiper';
import '@theme-modern-js/modules/main-search';
import '@theme-modern-js/modules/details-swiper';
import '@theme-modern-js/modules/single-swiper';
import '@theme-modern-js/modules/tabs-swiper';
import '@theme-modern-js/modules/counter';
import '@theme-modern-js/modules/recaptcha';
import '@theme-modern-js/modules/grid';
import '@theme-modern-js/modules/back-to-top';
import '@theme-modern-js/modules/offcanvas-menu';
import '@theme-modern-js/modules/main-menu';
import '@theme-modern-js/modules/password-strength';
import '@theme-modern-js/modules/strength-meter';
import '@theme-modern-js/modules/form-validator';
import '@theme-modern-js/modules/price';
import './custom-search';
// import './modules/solution-finder';
import '@theme-modern-js/modules/main-navigation-bar';
import '@theme-modern-js/modules/login';
import '@theme-modern-js/modules/select2';
import '@theme-modern-js/modules/variant-select';
import '@theme-modern-js/modules/show-hide-password';
import '@theme-modern-js/modules/datatable';
import '@theme-modern-js/modules/product-accordion';
import '@theme-modern-js/modules/address-invoice';
import '@theme-modern-js/modules/add-to-cart';
import './overrides/compare';
import '@theme-modern-js/modules/add-to-shopping-list';
import '@theme-modern-js/modules/cart';
import '@theme-modern-js/modules/fast-product-entry';
import '@theme-modern-js/modules/mini-cart';
import '@theme-modern-js/modules/radio-toggle';
import '@theme-modern-js/modules/favorites';
import '@theme-modern-js/modules/shop-select';
import '@theme-modern-js/modules/toggle-visibility-with-checkbox';
import '@theme-modern-js/modules/organisation-edit';
import '@theme-modern-js/modules/change-password';
import '@theme-modern-js/modules/datepicker';
import '@theme-modern-js/modules/add-order-items-to-cart';
import '@theme-modern-js/modules/customer-menu-logged-out';
import '@theme-modern-js/modules/news';
import '@theme-modern-js/modules/tree-view';
import '@theme-modern-js/modules/roles';
import '@theme-modern-js/modules/popovers';
import '@theme-modern-js/modules/address-reload';
import '@theme-modern-js/modules/contact';
import '@theme-modern-js/modules/enter-customer-data';
import '@theme-modern-js/modules/dependency-container';
import '@theme-modern-js/modules/filter/filter';
import '@theme-modern-js/modules/menu';
import '@theme-modern-js/modules/sort-cart';
import '@theme-modern-js/modules/favorite-detail';
import '@theme-modern-js/modules/options/product-options';
import '@theme-modern-js/modules/shown-accordion';
import '@theme-modern-js/modules/cta-actions';
import '@theme-modern-js/modules/create-retour-modal';
import '@theme-modern-js/modules/stores';
import '@theme-modern-js/utils/modal';
import '@theme-modern-js/modules/SwiperComponent'
import '@theme-modern-js/modules/offer'
import {tooltip} from "@theme-modern-js/modules/tooltips";
tooltip(document);
import '@theme-modern-js/modules/product-availability';

import Breadcrumb from '@theme-modern-js/modules/Breadcrumb'
const breadcrumb = new Breadcrumb();
breadcrumb.init();

import {registerHtmlHook} from '@theme-modern-js/utils/htmlHooks';
import {toggleOnChange} from "@theme-modern-js/modules/dependency-container";

import './magic-toolbox/magicscroll/magicscroll';
import './magic-toolbox/magiczoomplus/magiczoomplus';
import './magic-toolbox/magicthumb/magicthumb';

import './overrides';
import './shop';
import './custom/category-panel-workarround.js'

import './product-variant-swiper'

// Start magic scroll manually (if content was asyncly loaded)
registerHtmlHook((container) => MagicScroll.start());

window.registerHtmlHook = registerHtmlHook;
